var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.$style.overlay,
        ((_obj = {}), (_obj[_vm.$style.fixed] = _vm.fixed), _obj)
      ]
    },
    [_c("div", { class: _vm.$style.spinnerContainer }, [_c("moon-loader")], 1)]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/configurator/components/LoadingSpinner.vue?vue&type=template&id=3b5ea590&
// module id = null
// module chunks = 